// extracted by mini-css-extract-plugin
export default {"container":"DemoToolbar_container__71ktm","item":"DemoToolbar_item__ytCx8","divider":"DemoToolbar_divider__XjfBl"};